import { render, staticRenderFns } from "./right-center.vue?vue&type=template&id=49dc9e5c&"
import script from "./right-center.vue?vue&type=script&lang=js&"
export * from "./right-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports